import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import { IdWrapper } from "AtomicComponents"
import { StickyNav } from "AtomicContainers"
import componentParser from "AtomicUtils/componentParser"
import { gtmOffersActionTypes } from "store/gtm-events"

class OffersContainer extends PureComponent {
  render() {
    /* Todo the backend should only send offers array not array of OfferItem components */
    const offerCategories = this.props.offers
      .filter(c => c.name === "OfferItem")
      .map(o => ({
        notDisplay: false,
        name: o.props.title,
        slug: o.props.slug,
        rootPath: "/offers"
      }))
      .reduce(
        (items = [], item) =>
          (items.every(({ slug }) => slug !== item.slug) ? [...items, item] : items),
        []
      )
    const { components } = this.props

    return (
      <div>
        {offerCategories.length > 0 && (
          <StickyNav items={offerCategories} gtm={{ category: "Offers", action: "Clicked Sub Nav Link"}} gtmMapping={gtmOffersActionTypes} />
        )}
        {componentParser(components)}
        {offerCategories && offerCategories.map(({ slug }) => (
          <IdWrapper key={slug} slug={slug}>
            {componentParser(this.props.offers.filter(({ props }) => props.slug === slug))}
          </IdWrapper>
        ))}
      </div>
    )
  }
}

OffersContainer.propTypes = {
  offers: PropTypes.array.isRequired,
  children: PropTypes.node
}

export default Radium(OffersContainer)



// WEBPACK FOOTER //
// ./src/containers/offers/index.jsx